import {Injectable} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ParcelAppEntityParcelWrite
} from '../../../../../../openapi';
import {RoadControlsForm} from '../../components/road-controls-set/road-controls.form';
import {environment} from '../../../../../../../environments/environment';

@Injectable()
export class LocalisationForm extends RoadControlsForm {

  constructor() {
    super({
      geometry: new FormControl(null, environment.production ? Validators.required : []),
      parcels: new FormControl<ParcelAppEntityParcelWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public get geometry(): FormControl {
    return this.get('geometry') as FormControl;
  }

  public get parcels(): FormControl {
    return this.get('parcels') as FormControl;
  }

  public get parcelsValues(): ParcelAppEntityParcelWrite[] {
    return this.parcels.value;
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    const value = this.value;
    delete value.parcels;
    return {
      ...value,
      roadName: this.roadName.value,
      roadNumber: this.roadNumber.value,
      street: this.street?.value,
      geometry: this.geometry?.value
    };
  }

  public override patchFormValues(value: ApplicationAppEntityApplicationRead): void {
    super.patchValue({
      ...value
    });
  }

}
